// Usamos require.context para recorrer carpetas
/*export function getImagesProduct(folderName) {
  try {
    // Busca dentro de assets/productos/[folderName]
    const context = require.context(
      `../assets/productos/${folderName}`,
      false, // no buscar recursivamente
      /\.(png|jpe?g|webp|svg)$/ // extensiones válidas
    );

    // Retorna array de imágenes importadas
    return context.keys().map(context);
  } catch (e) {
    console.warn(`No se encontraron imágenes para ${folderName}`);
    return [];
  }
}*/
const imagesContext = {
  'etiquetas-transparentes': require.context('../assets/productos/etiquetas-transparentes', false, /\.(png|jpe?g|webp|svg)$/),
  'etiquetas-de-seguridad': require.context('../assets/productos/etiquetas-de-seguridad', false, /\.(png|jpe?g|webp|svg)$/),
  'etiquetas-booklet': require.context('../assets/productos/etiquetas-booklet', false, /\.(png|jpe?g|webp|svg)$/),
  
  'etiquetas-metalizadas': require.context('../assets/productos/etiquetas-metalizados', false, /\.(png|jpe?g|webp|svg)$/),
  'etiquetas-glow-in-the-dark': require.context('../assets/productos/etiquetas-glow-in-the-dark', false, /\.(png|jpe?g|webp|svg)$/),
  'etiquetas-transferencia-termica': require.context('../assets/productos/etiquetas-trasferencia-termica', false, /\.(png|jpe?g|webp|svg)$/),
  'etiquetas-stickers': require.context('../assets/productos/etiquetas-stickers', false, /\.(png|jpe?g|webp|svg)$/),
  'etiquetas-resellables': require.context('../assets/productos/etiquetas-resellables', false, /\.(png|jpe?g|webp|svg)$/),
  'etiquetas-scratch-off': require.context('../assets/productos/etiquetas-scratch-off', false, /\.(png|jpe?g|webp|svg)$/),
  'etiquetas-cold-foil': require.context('../assets/productos/etiquetas-cold-foil', false, /\.(png|jpe?g|webp|svg)$/),
  'etiquetas-con-aroma': require.context('../assets/productos/etiquetas-con-aroma', false, /\.(png|jpe?g|webp|svg)$/),
  'etiquetas-holograficas': require.context('../assets/productos/etiquetas-holograficas', false, /\.(png|jpe?g|webp|svg)$/),
  'etiquetas-nylon': require.context('../assets/productos/etiquetas-nylon', false, /\.(png|jpe?g|webp|svg)$/),
  'mangas-termoencogibles': require.context('../assets/productos/mangas-termoencogibles', false, /\.(png|jpe?g|webp|svg)$/),
  'vasos-promocionales': require.context('../assets/productos/vasos-promocionales', false, /\.(png|jpe?g|webp|svg)$/),
  'termoformado': require.context('../assets/productos/termoformado', false, /\.(png|jpe?g|webp|svg)$/),
  // Agrega el resto de carpetas aquí
};

export function getImagesProduct(folderName) {
  try {
    const context = imagesContext[folderName];
    if (!context) throw new Error(`No se encontró contexto para ${folderName}`);

    return context.keys().map(context);
  } catch (e) {
    console.warn(`No se encontraron imágenes para ${folderName}:`, e.message);
    return [];
  }
}
